import { App } from '@df/core/app';
import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';

export const pdpComponentVisibilityConditions: NICmsContentField.IRepeaterField = {
    type: NICmsContentField.EFieldType.repeater,
    key: 'styles.pdpComponentVisibilityConditions',
    title: 'Visibility by attribute value',
    description: 'Hides this component if product data meets the following conditions',
    group: NICmsContentComponent.EFieldGroup.styles,
    itemName: 'Rule',
    fields: [
        <NICmsContentField.IChoiceField>{
            key: 'logicOperator',
            type: NICmsContentField.EFieldType.choice,
            title: 'Logic operator',
            description: 'Select how to combine this rule and previous one (ignored on first rule)',
            options: [
                { key: 'and', title: 'and' },
                { key: 'or', title: 'or' }
            ],
            default: 'and',
            required: true
        },
        <NICmsContentField.IRelationField>{
            key: 'attribute',
            required: true,
            type: NICmsContentField.EFieldType.relation,
            title: 'For attribute...',
            options: {
                type: 'attribute',
                multiple: false
            }
        },
        <NICmsContentField.IChoiceField>{
            key: 'rule',
            type: NICmsContentField.EFieldType.choice,
            title: '...product data...',
            options: [
                { key: 'one', title: '...includes at least one of...' },
                { key: 'all', title: '...includes all of...' },
                { key: 'none', title: '...doesn\'t include any of...' }
            ],
            default: 'one',
            required: true,
            canShow: data => !!data.attribute
        },
        <NICmsContentField.IChoiceField>{
            key: 'options',
            multiple: true,
            type: NICmsContentField.EFieldType.choice,
            title: '...following options:',
            options: data => {
                if (typeof window !== 'undefined') {
                    const attr = (<App>window['app'])?.resources?.attribute?.get(data.attribute);
                    if (attr?.data?.options) {
                        return attr.data.options.map(i => {
                            return {
                                key: i.value,
                                value: i.value,
                                title: i.label.toString()
                            };
                        });
                    }
                }
                return [];
            },
            canShow: data => !!data.attribute,
            required: true
        },
        <NICmsContentField.IChoiceField>{
            key: '',
            multiple: false,
            type: NICmsContentField.EFieldType.choice,
            title: 'Current product selected attribute options (from product data) This field is for preview only, options cannot be selected.',
            options: data => {
                if (typeof window !== 'undefined') {
                    const attr = (<App>window['app'])?.resources?.attribute?.get(data.attribute);
                    const model = (<App>window['app'])?.meta.model;
                    const productData = model?.type === 'product' ? model.data?.[data.attribute] : undefined;
                    const productOptions = Array.isArray(productData) ? productData : [productData];
                    if (attr?.data?.options) {
                        return attr.data.options
                            .map(i => {
                                return {
                                    key: i.value,
                                    value: i.value,
                                    title: i.label.toString()
                                };
                            })
                            .filter(i => productOptions.includes(i.key));
                    }
                }
                return [];
            },
            canShow: data => !!data.attribute,
            required: false
        }
    ],
    complex: true,
    canShow: () => {
        if (typeof window !== 'undefined') {
            const model = (<App>window['app'])?.meta.model;
            return model?.type === 'product';
        }
        return false;
    }
};
